<template>
    <div class="pg-result">
        <div class="pg-result__box">
            <p class="pg-result__title" :class="{ 'pg-result__title--fail': !ok }">
                {{ ok ? "결제가 완료되었습니다" : "결제가 완료되지 않았습니다" }}
            </p>
            <p v-if="!ok && message" class="pg-result__message">{{ message }}</p>
            <p class="pg-result__guide">{{ guide }}</p>
            <button type="button" class="pg-result__button" @click="close">창 닫기</button>
        </div>
    </div>
</template>

<script>
import { notifyParent } from "@/plugins/pg-result-bridge";

// 쿠콘(/api/plugins/open-bank/pay) 복귀 → 서버 redirect 로 이 페이지가 결제창(iframe 또는 팝업) 안에서 열린다.
// 결과를 부모 화면에 알리고, 알림이 직접 닿았으면 닫는다. 닿지 않았으면(www 유무가 다른 호스트 등)
// 부모가 postMessage 로 받아 결제창을 닫으므로, 여기서는 화면으로 결과를 보여 두기만 한다.
const CHANNEL = "checkpay-result";
const FN = "checkpayComplete";

export default {
    data() {
        return { closing: false };
    },
    computed: {
        ok() {
            return (this.$route.query.resCode || "0000") === "0000";
        },
        message() {
            return this.$route.query.resMessage || "";
        },
        guide() {
            return this.closing ? "잠시 후 이 창이 닫힙니다." : "이 창을 닫고 결제 화면으로 돌아가 주세요.";
        },
    },
    created() {
        const direct = notifyParent(CHANNEL, FN, { ...this.$route.query });
        if (direct) {
            this.closing = true;
            setTimeout(() => this.close(), 300);
        }
    },
    methods: {
        close() {
            try {
                window.close();
            } catch (error) {
                // iframe 이거나 브라우저가 거부하면 그대로 둔다. 부모가 결제창을 닫는다.
            }
        },
    },
};
</script>

<style scoped>
.pg-result { display: flex; align-items: center; justify-content: center; min-height: 100vh; padding: 24px; background: #fff; font-family: -apple-system, BlinkMacSystemFont, "Malgun Gothic", "맑은 고딕", sans-serif; }
.pg-result__box { width: 100%; max-width: 360px; text-align: center; }
.pg-result__title { margin: 0 0 8px; font-size: 18px; font-weight: 700; color: #1a237e; word-break: keep-all; }
.pg-result__title--fail { color: #c62828; }
.pg-result__message { margin: 0 0 8px; font-size: 14px; color: #555; word-break: keep-all; }
.pg-result__guide { margin: 0 0 24px; font-size: 13px; color: #888; word-break: keep-all; }
.pg-result__button { padding: 10px 28px; border: 1px solid #1a237e; border-radius: 4px; background: #1a237e; color: #fff; font-size: 14px; cursor: pointer; }
</style>
